import { useForm, type FieldValues, type UseFormProps } from 'react-hook-form';
import { useUnsavedChanges } from './useUnsavedChanges';

export function useFormWithUnsavedChanges<
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
>(props?: UseFormProps<TFieldValues, TContext>) {
  const form = useForm<TFieldValues, TContext>(props);

  useUnsavedChanges({
    isDirty: form.formState.isDirty,
  });

  return form;
}
